import {
  IsNotEmpty,
  IsOptional,
  IsArray,
  ArrayMinSize,
  IsIn,
} from "class-validator";
import { Constants } from "@eagerdog/constants";

import { CourseDogSessionsDto } from "./course-dog-sessions.dto";

export class CourseRegistrationCreateDto {
  //
  @IsArray()
  @ArrayMinSize(1)
  course_registrations: CourseDogSessionsDto[];

  //   @IsOptional()
  //   @IsArray()
  //   add_ons?: EventAddOnDto[];

  @IsNotEmpty()
  @IsIn(Object.values(Constants.payment_method_type))
  payment_method_type: string = Constants.payment_method_type.card;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.registration_kind))
  registration_kind: string = Constants.registration_kind.owner;

  @IsOptional()
  payment_card_type?: string = Constants.payment_card_type.unknown;

  @IsOptional()
  cheque_number?: string;

  @IsOptional()
  discount_code?: string;

  // If an payment intent has been created, need to update it with re-calcualted amounts
  @IsOptional()
  payment_intent_id?: string;

  @IsOptional()
  transaction_id?: string;

  @IsNotEmpty()
  owner_id: string;

  @IsOptional()
  date_received?: Date;

  @IsOptional()
  need_check_waitlists?: boolean;

  @IsOptional()
  club_points_to_redeem?: number;

  @IsOptional()
  course_waitlist_id?: string;
}
